import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { IDropDownAction } from '../dropdown/models/drop-down-action.model';
import { IconComponent } from '../icon/icon.component';
import { TypoName } from '../typo/types/name.type';
import { Weight } from '../typo/types/weight.enum';
import { TypoComponent } from '../typo/typo.component';

@Component({
    selector: 'berry-no-data-found',
    standalone: true,
    imports: [CommonModule, TypoComponent, IconComponent, DropdownComponent, TranslateModule],
    templateUrl: './no-data-found.component.html',
    styleUrl: './no-data-found.component.scss'
})
export class NoDataFoundComponent {

    @Input() mode: 'page' | 'section' = 'page';
    @Input() avatarSize: 70 | 140 = 70;
    
    @Input() icon: string = 'folder_off';
    @Input() iconSectinMode: string = 'warning';

    @Input() label: string = '_NoResultsFound_Resources';
    @Input() body: string = '';

    @Input() dropDownActions: IDropDownAction[] = [];
    @Input() btnLabel !: string;

    @Input() labelType: TypoName = 't1';
    @Input() labelWeight: Weight = Weight._700;
}
